module.exports = __webpack_public_path__ + "img/repguide-testimonial-schoettler.9ca53a6c.jpg";